module.exports = __webpack_public_path__ + "static/bg-10-0294ae7037e472c36f6db97dd4d09aea.jpg";